<div class="border-radius-8 bg-white upper-section flex-1">
  <div class="modal-header-section">
    <h2 mat-dialog-title>{{ 'Change Background' | translate }}</h2>
    <mat-icon class="material-icons-outlined icon-right close-icon" (click)="close()">
      close
    </mat-icon>
  </div>
  <!--  Pattern Shapes -->
  <div class="body-section">
    <div class="heading-container">
      <p>{{ 'Pattern' | translate }}</p>
    </div>
    <div class="patterns-container">
      <div class="pattern-content" *ngFor="let pattern of currentSupportedBackgroundPatterns">
        <div
          class="pattern"
          [class.selected]="pattern.id === currentFrameBackgroundPattern"
          (click)="changePattern(pattern)"
        >
          <img *ngIf="pattern.image" [src]="'assets/imgs/' + pattern.image" [alt]="pattern.title" />
        </div>
        <div class="pattern_title">
          <ng-container *ngIf="isMobile$ | async; else withoutTruncate">
            <span>{{ pattern.title | translate | truncateString: 8 }}</span>
          </ng-container>
          <ng-template #withoutTruncate>
            <span>{{ pattern.title | translate }}</span>
          </ng-template>
        </div>
      </div>
    </div>
    <!--    Colors Patterns -->
    <div class="heading-container">
      <p>{{ 'Color' | translate }}</p>
    </div>
    <div class="patterns-container">
      <div class="pattern-content" *ngFor="let backgroundColor of currentSupportedBackgroundColors">
        <div
          class="pattern"
          [style.background-color]="backgroundColor.color"
          [class.selected]="backgroundColor.color === currentFrameColor"
          (click)="changePatternBackgroundColor(backgroundColor)"
        ></div>
        <div class="pattern_title">
          <span>{{ backgroundColor.label }}</span>
        </div>
      </div>

      <!--      Custom Color Picker-->
      <div class="pattern-content">
        <div class="pattern" [class.selected]="isCustomColorSelected" (click)="showPicker = true">
          <img src="assets/imgs/picker.png" alt="color picker" />
        </div>
        <div class="pattern_title">
          <span>{{ 'Custom' | translate }}</span>
        </div>
      </div>

      <ng-container *ngIf="colorPickLeftPosition$ | async as colorPickLeftPosition">
        <app-color-picker
          *ngIf="showPicker"
          [currentActiveColor]="currentFrameColor"
          [customParentStyle]="{ top: '20%', left: colorPickLeftPosition, bottom: 'initial' }"
          (closePicker)="showPicker = false"
          (selectPickerComplete)="changePatternWithCustomColor($event)"
        ></app-color-picker>
      </ng-container>
    </div>
    <!--    set default section-->
    <div class="checkbox-container">
      <mat-checkbox
        class="check-box"
        [color]="'primary'"
        (change)="handleDefaultBackgroundCheckbox($event)"
        [checked]="isDefaultBackgroundSelected()"
        [disabled]="isDefaultBackgroundSelected()"
        [appTooltip]="defaultBackground"
        [appTooltipDisabled]="!isDefaultBackgroundSelected()"
        [appTooltipPlacement]="'bottom-center'"
      >
      </mat-checkbox>
      <span>{{ 'Set as default for all new boards in this Space' | translate }}</span>
      <ng-template #defaultBackground>
        <app-tooltip
          [text]="'This background is already the default for this space' | translate"
          arrow="top"
        ></app-tooltip>
      </ng-template>
    </div>
  </div>
  <!--  Buttons Section -->
  <div class="buttons-section">
    <button class="cancel-btn modal-cancel-btn" (click)="close()">
      <mat-icon class="material-icons-outlined btn-icon">close</mat-icon>
      <span class="btn-text"> {{ 'Cancel' | translate }}</span>
    </button>
    <button
      class="update-btn confirm-btn"
      (click)="confirmChangeBackground()"
      [disabled]="shouldDisableConfirmButton()"
    >
      <mat-icon class="material-icons-outlined btn-icon">check</mat-icon>
      <span class="btn-text"> {{ 'Confirm' | translate }}</span>
    </button>
  </div>
</div>
